import React, { Component, Fragment } from 'react';
import {
    Container, Row, Col, Input, Label, Form, FormGroup, Button, Table
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faTrashAlt, faCheck, faWrench, faCopy, faEye } from '@fortawesome/free-solid-svg-icons';
import ConfirmButton from '../Modal/ConfirmButton';
import { Link } from 'react-router-dom';
// import ReactTable from 'react-table';

class Marketing2Campaigns extends Component {

    formatDate = (d) => {
        if (d == null) return "";
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        const content = row[id];
        if (typeof content !== 'undefined') {
            // filter by text in the table or if it's a object, filter by key
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
            } else {
                return String(content).toLowerCase().includes(filter.value.toLowerCase());
            }
        }
        return true;
    };

    standardRow = (marketingCampaign) => {
        return (
            <tr className="adminRow pointer text-left" onClick={() => this.props.onEdit(marketingCampaign.campaignID)}>
                <td>{marketingCampaign.name}</td>
                <td>{marketingCampaign.description}</td>
                <td>{this.props.workflowTypes.find(item => String(item.workflowTypeId) === String(marketingCampaign.type))?.workflowTypeLabel || ''}</td>
                <td>{this.formatDate(marketingCampaign.startDate)}</td>
                <td>{this.formatDate(marketingCampaign.endDate)}</td>
                <td>{marketingCampaign.active ? "Active" : "Inactive"}</td>
            </tr>
        )
    }

    editRow = (campaign) => {
        return (
            <tr className="editRow adminRow">
                <td colSpan={6}>
                    <Row className="py-2 text-left align-items-bottom ">
                        <Col className="text-left">
                            <Form inline>
                                <FormGroup className="mr-2">
                                    <Input
                                        placeholder="Name"
                                        name="name"
                                        value={this.props.editMarketingCampaign.name + ''}
                                        onChange={e => this.props.onChange(e, 'edit')} />
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        placeholder='Description'
                                        name="description"
                                        value={this.props.editMarketingCampaign.description + ''}
                                        onChange={e => this.props.onChange(e, 'edit')} />
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type='select'
                                        name="type"
                                        value={this.props.editMarketingCampaign.type + ''}
                                        onChange={e => this.props.onChange(e, 'edit')} >
                                        <option value="">SELECT TYPE</option>
                                        {this.props.workflowTypes.map(workflowType => (
                                            <option key={workflowType.workflowTypeId} value={workflowType.workflowTypeId}>{workflowType.workflowTypeLabel}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type="date"
                                        name="startDate"
                                        value={this.props.editMarketingCampaign.startDate != null ? this.props.editMarketingCampaign.startDate.substring(0, 10) : ''}
                                        onChange={e => this.props.onChange(e, 'edit')}>
                                    </Input>
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type="date"
                                        name="endDate"
                                        value={this.props.editMarketingCampaign.endDate != null ? this.props.editMarketingCampaign.endDate.substring(0, 10) : ''}
                                        onChange={e => this.props.onChange(e, 'edit')}>
                                    </Input>
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Label>
                                        <Input
                                            type="checkbox"
                                            name="active"
                                            checked={this.props.editMarketingCampaign.active}
                                            onChange={e => this.props.onChange(e, 'edit')}>
                                        </Input>Active
                                    </Label>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                    <Row className="py-2 text-left align-items-bottom ">
                        <Col>
                            {campaign?.companiesList?.map(company => (
                                <div><Link to={{ pathname: '/demographics/' + company['SEC#'], state: {} }}>{company['Primary Business Name']} ({company['SEC#']})</Link></div>
                            ))}
                        </Col>
                        <Col md={4} className="text-right">
                            <Button className="mr-3" color="success" onClick={this.props.handleEdit} title="Edit Workflow">
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                            <Button /*disabled={this.props.editMarketingCampaign.companies > 0}*/ className="mr-3" color="primary" onClick={() => this.props.onToggleConfigureMarketingCampaign(campaign.campaignID)} title="Configure Workflow">
                                <FontAwesomeIcon icon={this.props.editMarketingCampaign.companies > 0 ? faEye : faWrench} />
                            </Button>
                            <Button className="mr-4" color="primary" onClick={() => this.props.onToggleDuplicateMarketingCampaign(campaign.campaignID)} title="Duplicate Workflow">
                                <FontAwesomeIcon icon={faCopy} />
                            </Button>
                            <ConfirmButton disabled={this.props.editMarketingCampaign.companies > 0} className="mr-4" color="danger" onClick={() => this.props.onDelete(campaign.campaignID)} edit="Delete Workflow">
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </ConfirmButton>
                            <Button className="mr-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
                                <FontAwesomeIcon icon={faTimes} />
                            </Button>
                        </Col>
                    </Row>
                </td>
            </tr>
        )
    }

    addRow = () => {
        return (
            <tr>
                <td colSpan={6}>
                    <Row className="py-2 mt-5 text-left align-items-bottom ">
                        <Col>
                            <Form inline>
                                <FormGroup className="mr-2">
                                    <Input
                                        placeholder="Name"
                                        name="name"
                                        value={this.props.newMarketingCampaign.name + ''}
                                        onChange={this.props.onChange} />
                                </FormGroup>
                                <FormGroup className='mr-2'>
                                    <Input
                                        placeholder="Description"
                                        name="description"
                                        value={this.props.newMarketingCampaign.description + ''}
                                        onChange={this.props.onChange} />
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type='select'
                                        name="type"
                                        value={this.props.newMarketingCampaign.type + ''}
                                        onChange={this.props.onChange} >
                                        <option value="">SELECT TYPE</option>
                                        {this.props.workflowTypes.map(workflowType => (
                                            <option key={workflowType.workflowTypeId} value={workflowType.workflowTypeId}>{workflowType.workflowTypeLabel}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type="date"
                                        name="startDate"
                                        value={this.props.newMarketingCampaign.startDate.substring(0, 10)}
                                        onChange={this.props.onChange} />
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Input
                                        type="date"
                                        name="endDate"
                                        value={this.props.newMarketingCampaign.endDate.substring(0, 10)}
                                        onChange={this.props.onChange} />
                                </FormGroup>
                                <FormGroup className="mr-2">
                                    <Label>
                                        <Input
                                            type="checkbox"
                                            name="active"
                                            checked={this.props.newMarketingCampaign.active}
                                            onChange={this.props.onChange} />
                                        Active
                                    </Label>
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col md={2} className="text-right px-0">
                            <Button
                                disabled={this.props.newMarketingCampaign.campaign === ''}
                                color="primary"
                                onClick={this.props.handleAdd}
                            >Add Workflow</Button>
                        </Col>
                    </Row>
                </td>
            </tr>
        )
    }

    render() {
        return (
            <Container className="adminContainer" fluid>
                <Table width="100%">
                    <thead>
                        <tr className='text-left'>
                            <th width="25%">Workflow Name</th>
                            <th width="30%">Description</th>
                            <th width="15%">Type</th>
                            <th width="10%">Start Date</th>
                            <th width="10%">End Date</th>
                            <th width="10%">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.marketingCampaigns.map(marketingCampaign => (
                            <Fragment key={marketingCampaign.campaignID}>{this.props.editMarketingCampaign.campaignID === marketingCampaign.campaignID ? this.editRow(marketingCampaign) : this.standardRow(marketingCampaign)}</Fragment>
                        ))}
                        {this.addRow()}
                    </tbody>
                </Table>
            </Container>
        );

    }
}

export default Marketing2Campaigns;